import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=f20d5328&scoped=true&"
import script from "./Manual.js?vue&type=script&lang=js&"
export * from "./Manual.js?vue&type=script&lang=js&"
import style0 from "./Manual.css?vue&type=style&index=0&id=f20d5328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d5328",
  null
  
)

export default component.exports